import { useEffect, useState } from 'react';
import {CoffeeUnderground} from './components/CoffeeUnderground';
import {ExceptionalCoffees} from './components/ExceptionalCoffees';
import {ExclusiveCoffees} from './components/ExclusiveCoffees';
import {FellowTasters} from './components/FellowTasters';
import {Footer} from './components/Footer';
import {Header} from './components/Header';
import {HowItWorks} from './components/HowItWorks';
import {SendANerd} from './components/SendANerd';
import {TextedBack} from './components/TextedBack';
import {TheCoffeesWeChoose} from './components/TheCoffeesWeChoose';
import "./Landing.css";

export const Landing = () => {
  const [token, setToken] = useState('');

  useEffect(() => {
    fetch('/csrf', {
    }).then(response => {
        setToken(response.headers.get('X-CSRFToken'));
    });
  }, []);

  return (
    <div>
      <Header />
      {token &&
      <div className="landingMain" >
        <ExclusiveCoffees token={token}/>
        <HowItWorks />
        <SendANerd token={token}/>
        <TheCoffeesWeChoose />
        <FellowTasters />
        <TextedBack />
        <CoffeeUnderground token={token}/>
        <ExceptionalCoffees />
        <Footer />
      </div>
      }
    </div>  
  );
}
